import { useI18n } from "../../i18n/i18nContext";

const TermsAndConditions = () => {
    const { t } = useI18n();
    return (
        <div className="mt-8 text-gray-400 text-xs text-center">
            <p className="mb-4">
                {t('checkout.termsNotice')} <a href="https://sellyo.com.br/terms-of-use/" target="_blank" rel="noopener noreferrer" className="text-blue-600 font-semibold hover:text-blue-800 underline">{t('checkout.termsOfUse')}</a>, <a href="https://sellyo.com.br/terms-of-use/" target="_blank" rel="noopener noreferrer" className="text-blue-600 font-semibold hover:text-blue-800 underline">{t('checkout.privacyPolicy')}</a> {t('checkout.legalNotice')}
            </p>

            <p className="text-gray-400 text-xs italic mb-4">
                {t('checkout.payWithCryptos')}
            </p>

            <div className="flex justify-center items-center gap-2 mb-4">
                <div className="text-xs text-center text-gray-400">
                    <p className="uppercase font-semibold">{t('checkout.copyright')}</p>
                    <p className="text-xs">{t('checkout.rights')}</p>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;